export async function useFetchNativeLands({ latitude, longitude }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const params = computed(() => ({
    maps: "territories",
    position: `${round(latitude, 4)},${round(longitude, 4)}`,
  }));
  return useLazyFetch("https://native-land.ca/wp-json/nativeland/v1/api/index.php", {
    params,
    transform: (response) =>
      response.map((feature) => ({
        name: feature.properties.Name,
        url: feature.properties.description,
      })),
  });
}
